import React, { useState } from "react";
import { Container, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles.css";
import api from "../../services/api"; // Import the api instance directly

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // Add state for password visibility
  // const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Call the login API with email and password directly using the api instance
      const response = await api.post("/login", { email, password });
  
      // Calculate the expiration time
      const expiresIn = response.data.expires_in; // seconds
      const expirationTime = new Date().getTime() + expiresIn * 1000; // milliseconds
  
      // Store the access token and expiration time in localStorage
      localStorage.setItem("access_token", response.data.access_token);
      localStorage.setItem("token_type", response.data.token_type);
      localStorage.setItem("expires_in", expirationTime.toString());
  
      // Store user information
      localStorage.setItem("user", JSON.stringify(response.data.user));
      localStorage.setItem("isAuthenticated", "true");
  
      // Show success toast
      toast.success("Connexion réussie!");
      
      // Redirect to home page after successful login
      setTimeout(() => {
        navigate("/");
      }, 1000); // Wait 1 second before redirecting
    } catch (err) {
      toast.error("E-mail ou mot de passe invalide");
      console.error("Login error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => { // Add function to toggle visibility
    setShowPassword(!showPassword);
  };

  return (
    <HelmetProvider>
      <ToastContainer />
      <Helmet>
        <title>Connexion - ProtectLease</title>
        <meta
          name="description"
          content="Connectez-vous à votre compte ProtectLease"
        />
      </Helmet>

      <Container className="login-container">
        <div className="login-form-container">
          <div className="login-header">
            <img
              src="/logo2.png"
              alt="ProtectLease Logo"
              className="login-logo"
            />
          </div>

          <p className="login-subtitle mt-4">Connexion</p>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Adresse e-mail *</Form.Label>
              <Form.Control
                type="email"
                placeholder="Adresse e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3 password-input-container" controlId="formBasicPassword"> {/* Add a class for styling */}
              <Form.Label>Mot de passe *</Form.Label>
              <Form.Control
                type={showPassword ? "text" : "password"} // Use state to toggle type
                placeholder="Mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <img
                src={showPassword ? "/eye.png" : "/eye-closed.png"}
                alt="Toggle password visibility"
                className="password-toggle-icon"
                onClick={togglePasswordVisibility}
              />
            </Form.Group>

            {/* <div className="d-flex justify-content-between align-items-center mb-4">
              <Form.Group controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Se souvenir de moi"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
              </Form.Group>
            </div> */}
            {/* ========== FOOTER SECTION ========== */}
            <div className="footer shadow-lg d-flex flex-column justify-content-center">
              <button
                type="submit"
                className="primary-button w-100 login-button mb-2"
                disabled={isLoading}
              >
                {isLoading ? "Connexion en cours..." : "Se connecter"}
              </button>

              <button
                type="button" // Changed from "submit" to "button"
                className="secondary-button w-100 azure-button"
                onClick={() => window.open("https://bo.leaseprotect.lebackyard.ovh/api/v1/login-azure", "_self")}
              >
                <img
                  src="/MS-icon.png"
                  alt="Microsoft Azure Icon"
                  className="ms-icon "
                />
                Continuer avec Microsoft Azure
              </button>
            </div>
          </Form>
        </div>
      </Container>
    </HelmetProvider>
  );
};

export default Login;
